export enum TypeReport {
  HAM = 'ham',
  SPAM = 'spam',
  PHISHI = 'phish',
  SENDER = 'Sender',
  RECIPIENT = 'Recipient'
}
